import React from "react";

import MIMMFlyerPdf from '../../assets/Study-Flyer-with-QR-Code -2020-Final.pdf';
import MIMMInstructions3Months from '../../assets/MIMMRemote-ParentGuidance-3months-pages-1.pdf';
import MIMMInstructions6Months from '../../assets/MIMMRemote-ParentGuidance-6months-pages-1.pdf';
import EMMACPConsentForm from '../../assets/EMMA CP Permission Form V1 Oct 2022 STAMPED.pdf';

import htfVideo from '../../assets/img/HTF-2-watermarked.mp4';
import btbVideo from '../../assets/img/BTB1-30s.mov';

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  CardFooter,
  Collapse,
  FormGroup,
  Form,
  Input,
  Modal,
  ModalFooter,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  Carousel,
  CarouselItem,
  CarouselIndicators,
  UncontrolledCollapse
} from "reactstrap";


import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box, Grid}
from '@mui/material';

import { ExpandMoreOutlined } from "@mui/icons-material";
import {Typography} from '@mui/material';

import ScrollTransparentNavbarEM from "../../components/Navbars/ScrollTransparentNavbarEM";

import ScrollTransparentNavbar from "../../components/Navbars/ScrollTransparentNavbar";
import FooterBlackEM from "components/Footers/FooterBlackEM";
import { isElementAccessExpression } from "typescript";



function StudiesEM(props) {

  const [propState, setPropState] = React.useState(props);

  // header 3 carousel states and functions
  const [activeIndex, setActiveIndex] = React.useState(propState.projectindex);
  const [animating, setAnimating] = React.useState(false);

  const [emmaModal, setEmmaModal] = React.useState(false);

  const [mimmModal, setMimmModal] = React.useState(false);
  const [appsModal, setAppsModal] = React.useState(false);


  const [videoModal, setVideoModal] = React.useState(false);
  const [appsExpanded, setAppsExpanded] = React.useState(false);




  const handleAppsChange = (panel) => (event, isExpanded) => {
    setAppsExpanded(isExpanded ? panel: false);
  }
  

  const onExiting = () => {
    setAnimating(false);
  };
  const onExited = () => {
    setAnimating(false);
  };
  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };
  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };
  const goToIndex = newIndex => {
    if (animating) return;
    setActiveIndex(newIndex);
  };
  //CAROUSEL ITEMS

// core components
const items = [

  {
    src: "url(" + require("assets/img/emma-project-background.jpg") + ")",
    content: (
      <div>
      <Row>
        <Col className="ml-auto mr-auto text-center" md="8">
          <h2 className="title">Project Cribsy</h2>
          <p className="text-success">
            <b> Phase I enrollment is now closed. We completed the Phase I pilot with 40 infants at four community
              clinics in Washington and Kansas, thanks to our Patient Navigators and the generous families. Thank you!
            </b>
          </p>
          <p className="text-info">
          <b>Phase II study: recruitment expected to begin Spring 2027</b>
          </p>
          <p className="em-p-light">
          Cribsy is a smartphone-based screener for neuromotor risk in the first year of life. Parents record short
          videos of their infant at home, and AI models analyze the infant's movements to flag risk for a clinician
          to review. With a new NIH Phase II award (2026-2029), we will validate Cribsy in 300 infants through
          twenty pop-up clinics run with community Patient Navigators, and connect it to the tools pediatricians
          already use.
          </p>

          <br></br>

          <p className="em-p-light">
          We will be recruiting infants between 3 and 12 months (corrected age).
          You will need a smartphone to acquire short videos of your baby in the crib (or on the floor).
          The study will support both English and Spanish speaking parents.
          Check back here, or follow our <a href="/news">news</a>, for the enrollment announcement.
          </p>
          <div className="buttons">

              <Button
                disabled
                outline
                className="mr-1"
                color="neutral"
                size="sm"
                title="Enrollment has not opened yet"
                style={{ opacity: 0.5, cursor: "not-allowed" }}
              >
                <i className="now-ui-icons ui-1_lock-circle-open"></i> <b>Enroll (not yet open) </b>
              </Button>

              <Button
                className="btn-neutral mr-1"
                color="info"
                href="#"
                onClick={()=>setEmmaModal(true)}
                size="sm"
              >
                <i className="now-ui-icons ui-1_check"></i> <b>Details </b>
              </Button>

              <Button
                  className="btn-neutral mr-1"
                  color="danger"
                  href="#"
                  size="sm"
                  onClick={()=>setAppsModal(true)}
                >
                <i className="now-ui-icons tech_mobile"></i> <b>Apps</b>
              </Button>

            <p className="em-p-light">
              <br></br>
              The Early Markers study group or Principal Investigator, Dr. Modayur can be contacted at
              <br></br>
              <a href="mailto:study@earlymarkers.com"> Email </a>
              <br></br>
              <a href="tel:12067452872">Phone at 1-206-745-2872</a>
              <br/>
            </p>

            <Modal
                fullScreen
                isOpen={emmaModal}
                toggle={() => setEmmaModal(false)}>
              <div className="modal-header justify-content-center">
                  <button
                    aria-hidden={true}
                    className="close"
                    onClick={() => setEmmaModal(false)}
                    type="button"
                  >
                    <i className="now-ui-icons ui-1_simple-remove"></i>
                  </button>
                  <h4 className="category text-info" align="center">Cribsy Phase II Validation Study</h4>
                </div>
                <div className="modal-body">

              <h6>ABOUT THE STUDY</h6>
              <p className="em-p-dark">
              Early Markers, a Seattle research firm funded by the National Institutes of Health, has received a
              Small Business Innovation Research Phase II award from the Eunice Kennedy Shriver National Institute of
              Child Health and Human Development (NICHD) to validate Cribsy, our smartphone-based screener for
              neuromotor risk in infants. The three-year study (2026-2029) will enroll 300 infants between 3 and 12
              months (corrected age) through twenty pop-up screening clinics run with community Patient Navigators
              in rural and under-resourced areas, and will connect Cribsy with the CHADIS platform used by pediatric
              practices so that a positive screen can be followed up quickly.
              </p>
              <br></br>

              <h6>WHAT PARTICIPATION WILL INVOLVE</h6>
              <p className="em-p-dark">
                <ul>
                  <li>
                  Attend a pop-up clinic near you, where a trained occupational therapist will guide you through the process.
                  </li>
                  <li>
                  Use your smartphone and the Cribsy app to record a short video of your baby, awake and not fussy, in the crib or on the floor.
                  </li>
                  <li>
                  A licensed occupational or physical therapist will review the video and share a developmental risk assessment
                  report with you, with referrals for follow-up care if appropriate.
                  </li>
                  <li>
                  You will receive a thank-you gift for your participation.
                  </li>
                </ul>
              Recruitment is expected to begin in Spring 2027. The consent form, eligibility details, and IRB information
              will be posted here when enrollment opens. The study will support both English and Spanish speaking parents.
              </p>
              <br></br>

              <h6>PHASE I (2024-2026)</h6>
              <p className="em-p-dark">
              In Phase I we built the Cribsy app in English and Spanish and screened 40 infants at four pop-up clinics in
              Washington and Kansas, including on Lummi and Nooksack tribal lands. The pilot showed that home videos recorded
              by parents can be analyzed automatically to flag neuromotor risk, and it set the stage for the Phase II
              validation study. Read more on our <a href="/news">news page</a>.
              <br></br><br></br>
              Email us at study@earlymarkers.com - Or call/text 206 745 2872
              </p>

              </div>
                <ModalFooter>
                  <Button color="primary" onClick={() => setEmmaModal(false)}>
                    Close
                  </Button>
                </ModalFooter>
              </Modal>

              <Modal 
                fullScreen
                isOpen={appsModal}
                toggle={() => setAppsModal(false)}>
              <div className="modal-header justify-content-center">
                <Typography variant='body1'>
                <Box sx={{ fontWeight: 'bold'}}>Cribsy App
                </Box> </Typography>
              </div>
              <div className="modal-body">
              <Accordion expanded={appsExpanded === 'appsPanel1'} onChange={handleAppsChange('appsPanel1')}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreOutlined />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography color='primary'>iOS App</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <a href="https://apps.apple.com/us/app/cribsy/id6499236782">
                      <img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/white/en-us?size=250x83&amp;releaseDate=1665100800&h=dcb22a6433c4aa556ff0d7bccb6ba928"
                       alt="Download on the App Store" /></a>

                  </AccordionDetails>
                </Accordion>

              <Accordion expanded={appsExpanded === 'appsPanel2'} onChange={handleAppsChange('appsPanel2')}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreOutlined />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography color='primary'>Android App</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                  
                    <a href='https://play.google.com/store/apps/details?id=com.earlymarkers.cribsy&pcampaignid=web_share'>
                      <img alt='Get it on Google Play' 
                      src={require("assets/img/google_play_badge.png")} height='83px'/></a>

                  </AccordionDetails>
                </Accordion>


                <Accordion expanded={appsExpanded === 'appsPanel3'} onChange={handleAppsChange('appsPanel3')}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreOutlined />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography color='primary'>How to get started</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                      

                    <Typography color='black'>
                      Here are some tips on how best to take crib videos.
                    </Typography>

                    <a href="https://youtu.be/jKOm49wJ9Aw" target="_blank">
                      Watch it on YouTube (English)</a>
                    <br/>
                    <br/>
                    <a href="https://youtu.be/81fX677PoHM" target="_blank">
                      Watch it on YouTube (Spanish)
                      </a>

                  </AccordionDetails>
                </Accordion>

                <ModalFooter>
               
               <Button color="primary" onClick={() => setAppsModal(false)}>
                 Close
               </Button>
             </ModalFooter>
              </div>
              </Modal>

          </div>
        </Col>
      </Row>
      </div>
    ),
    altText: "",
    caption: ""
  },
  {
    src: "url(" + require("assets/img/studyroom-wall-dark.jpg") + ")",
    content: (
      <div>
      <Row>
       
        <Col className="ml-auto mr-auto text-center" md="8">
        <h2 className="title">Motor Minutes</h2>
          <p className="em-p-light"> 
            We are building a library of Parent Activity Module (PAM) videos to help parents with play-based activities that can augment their child's development and
            enhance parent-child bond.
            <br></br>
            The play-based activity videos will be delivered as part of the EMMA app that is currently under development. Look here for some sample videos.
     
          </p>

         <div className="buttons">
            <Button
              className="btn-neutral mr-1"
              color="red"
              href="#"
              onClick = {()=>setVideoModal(true)}
              size="lg"
              id="sampleVideoToggler"
            >
              <i  className="now-ui-icons files_single-copy-04"></i>  Click here
            </Button>

            <Button
              color="info"
              href="/index#contact-em"
              size="lg"
            >
              <i className="now-ui-icons arrows-1_share-66"></i> Contact Us
            </Button>
           
          </div>

          <Modal 
                isOpen={videoModal}
                toggle={() => setVideoModal(false)}>
              <div className="modal-header justify-content-center">
                  <button
                    aria-hidden={true}
                    className="close"
                    onClick={() => setVideoModal(false)}
                    type="button"
                  >
                    <i className="now-ui-icons ui-1_simple-remove"></i>
                  </button>
                  <h4 className="category text-info">Sample Motor Minutes</h4>
                </div>
                <div className="modal-body">
                <Card className="card-blog card-plain" data-background-color="black" style={{ item: 'center' }}>

                  <CardBody>
                      <h6 className="category text-info">Hands to Feet</h6>
                      <CardTitle tag="h4">
                            <a href="#pablo" onClick={e => e.preventDefault()}>
                          Bringing hands to feet
                          </a>
                      </CardTitle>
                      <p className="card-description">
                        Wake up baby's feet and legs with touch and texture.
                      </p>
                    
                    
                      <div className="card-video">
                              <video controls
                                alt="..."
                                width="420"
                              >
                                <source src={htfVideo} type="video/mp4"/>
                              </video>
                          </div>
                    </CardBody>

                  <CardBody>
                      <h6 className="category text-warning">Back To Belly</h6>
                      <CardTitle tag="h4">
                            <a href="#pablo" onClick={e => e.preventDefault()}>
                         Back to belly
                          </a>
                      </CardTitle>
                      <p className="card-description">
                        Shows how to begin with gentle rocking back and forth from the hips; the weight shift that begins rolling.
                      </p>
                    
                    
                      <div className="card-video">
                              <video controls
                                alt="..."
                                width="420"
                              >
                                <source src={btbVideo} type="video/mp4"/>
                              </video>
                          </div>
                    </CardBody>

                  </Card>
                </div>
                <ModalFooter>
                 
                  <Button color="primary" onClick={() => setVideoModal(false)}>
                    Close
                  </Button>
                </ModalFooter>
              </Modal>

        
        </Col>
      </Row>
     
      <Row>

        <Col className="ml-auto mr-auto" md="8">

        
        </Col>
      </Row>
      </div>
    ),
    altText: "",
    caption: ""
  },
  {
    src: "url(" + require("assets/img/studyroom-adele.jpg") + ")",
    content: (
      <div>
      <Row>
        <Col className="ml-auto mr-auto text-center" md="8">
          <h2 className="title">Project MIMM</h2>
          <p className="em-p-light"> 
           {/* used to be  <h4 className="description text-white"> */}
           
          <p className="text-success">
            
            <b> Enrollment for this study is now closed. We successfully completed the pilot thanks to the  wonderful, skilled Kindering
              staff and the generous parents. Watch this space for further updates.
            </b>
            
          </p>
          <br></br>
             We are now kicking off the final portion of this infant study at Kindering, our clinical partner. Kindering is WA state's largest birth-to-three
            neurodevelopmental center. We are excited to partner with Kindering in bringing an early developmental screening tool to underserved population.
          </p>
          <br></br>
          <div className="buttons">
            <Button
              className="btn-neutral mr-1"
              color="red"
              href="#"
              id="mimmToggler"
              onClick={()=>setMimmModal(true)}
              size="lg"
            >
              <i className="now-ui-icons files_single-copy-04"></i> Read More..
            </Button>
            <Button
              disabled
              color="info"
              href="https://earlymarkers.youcanbook.me/"
              size="lg"
            >
            <i className="now-ui-icons arrows-1_share-66"></i> Book Now
            </Button>
           
           <Modal 
                isOpen={mimmModal}
                toggle={() => setMimmModal(false)}>
              <div className="modal-header justify-content-center">
                  <button
                    aria-hidden={true}
                    className="close"
                    onClick={() => setMimmModal(false)}
                    type="button"
                  >
                    <i className="now-ui-icons ui-1_simple-remove"></i>
                  </button>
                  <h4 className="category text-info">Project MIMM</h4>
                </div>
                <div className="modal-body">
                <h5 className="category text-info">Pilot at Kindering</h5>
              Parents can participate by attending a study session, with their infant, at the Kindering Bellevue site.
              The session will be virtual in that the occupational therapist will be on site (not in the study room) and 
              will be directing the play and handling of the infant over Zoom.
              
              <br>
              </br>
              Parents can choose to receive a motor developmental report of their participating infant.

              <br></br>
              If you're participating in MIMM, in preparation for the study session, you can look at
              the following instructions to familiarize yourself with what will happen during the 
              session:
                    <br>
                  </br>
                  <a href = {MIMMInstructions3Months} target = "_blank"> Instructions for 3-Month Olds </a>
                  <br>
                  </br>

                  <a href = {MIMMInstructions6Months} target = "_blank"> Instructions for 6-Month Olds </a>
                  <br>
                  </br>
                  <br>
                  </br> 
              For additional details, see the flyer below
              <br></br>
              <a href = {MIMMFlyerPdf} target = "_blank"> Check out the recruitment flyer here </a>
              <br></br>

              <br></br>
              <h5 className="category text-info">About MIMM</h5>
            
                  This study, Modeling Infant Motor Movements (MIMM), is designed to obtain high quality movement data from infants in a naturalistic
            setting. We needed high-quality infant movement data, obtained from video cameras, to train our AI system to recognize
               infant body joints (pose estimation) and motor activities. As part of this effort, we commissioned a study
              in 2017 to gather infant movement data. Infants of both sexes, in the age group 3-, 6-, 9-, and 12-months, were recruited
              from the greater Seattle area. Thanks to the overwhelming support of parents, we were able to gather data from
              over 60 infants in short assessment sessions.
              <br></br>
              An extended labeling phase yielded a couple of million infant body joint locations, manually and painstakingly labeled.
              This training data was used to produce a state of the art infant pose estimation system that can predict
              the body joint locations of infants from video.
              <br>
              </br>
              We also labeled motor activity sequences from videos, producing over 3000 such samples for training of our 
              Activity Classifier.   
            
              
                </div>
                <ModalFooter>
                 
                  <Button color="primary" onClick={() => setMimmModal(false)}>
                    Close
                  </Button>
                </ModalFooter>
              </Modal>

       
          </div>
        </Col>
      </Row>
      </div>
    ),
    altText: "",
    caption: ""
  },


];
  
  return (
  
    <>
     <ScrollTransparentNavbarEM/>
      <div className="cd-section wrapper" id="headers">
       
        <div className="header-3">
         
          <Carousel activeIndex={activeIndex} next={next} previous={previous} interval={false} touch={true}>
            <CarouselIndicators
              items={items}
              activeIndex={activeIndex}
              onClickHandler={goToIndex}
              color="primary"
            />
            {items.map(item => {
              return (
                <CarouselItem
                  onExiting={onExiting}
                  onExited={onExited}
                  key={item.src}
                >
                  <div className="page-header header-filter">
                    <div
                      className="page-header-image"
                      style={{
                        backgroundImage: item.src
                      }}
                    ></div>
                    <div className="content">
                      <Container className="text-left">
                        {item.content}
                      </Container>
                    </div>
                  </div>
                </CarouselItem>
              );
            })}
            <a
              className="left carousel-control carousel-control-prev"
              data-slide="prev"
              href="#pablo"
              onClick={e => {
                e.preventDefault();
                previous();
              }}
              role="button"
            >
              <span className="carousel-control-prev-icon info" />
              <span className="sr-only">Previous</span>
            </a>
            <a
              className="right carousel-control carousel-control-next"
              data-slide="next"
              href="#pablo"
              onClick={e => {
                e.preventDefault();
                next();
              }}
              role="button"
            >
              <span className="carousel-control-next-icon" color="info" />
              <span className="sr-only">Next</span>
            </a>
          </Carousel>
        </div>

      </div>
     
      
      <FooterBlackEM/>
    </>
  );
}

export default StudiesEM;